import { Tag, Tooltip, Spin } from 'antd'; // 引入 antd 组件
import { CheckCircleFilled, CopyOutlined, LoadingOutlined, CloseCircleFilled } from '@ant-design/icons';
import { strDot } from "@/utils";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import "./index.less";
import Loader from '@/components/Loader';
import { ETHERSCAN_URL } from '@/config';
import { cdnUrl } from '@/utils/cdn';

interface TagProps {
  txt: string;
  status: 'loading' | 'noStart' | 'success' | 'fail';
  hash?: string;
  msg?: string;
  onCopy?: () => void;
  onClick?: () => void;
  replaceContent?: React.ReactNode,
  btnText?: string,
}

const TransactionTag = ({ txt, status, hash, msg, onCopy, replaceContent }: TagProps) => {
  const scanTx = (hash: string) => `https://suiscan.xyz/mainnet/tx/${hash}`; // 区块链浏览器地址

  // 根据状态进行渲染
  if (status === 'loading') {
    return (
      <Tag className="load-tag">
        {/* <Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} /> 加载状态 */}
        <Loader>
          <img style={{ width: "20px" }} src={cdnUrl("/img/loading-grey.webp")} alt="" />
        </Loader>
      </Tag>
    );
  }

  if (status === 'noStart') {
    return (
      <Tag style={{ fontSize: "12px" }} className="load-tag">
        {txt}
      </Tag>
    );
  }

  if (status === 'success') {
    return (
      <Tag className="success-tag">
        <CheckCircleFilled className="success-icon" /> {/* 成功图标 */}
        {
          !replaceContent ? <>
            <a target="_blank" rel="noopener noreferrer" href={scanTx(hash!)}>
              {strDot(hash!)}
            </a>
            <CopyToClipboard text={hash!} onCopy={onCopy}>
              {/* <Tooltip title="Copy">
                <CopyOutlined />
              </Tooltip> */}
              <CopyOutlined />
            </CopyToClipboard>
          </>
            : replaceContent
        }
      </Tag>
    );
  }

  return (
    <Tag color="error" className="fail-tag">
      <CloseCircleFilled className="fail-icon" />
      {
        !replaceContent ? <>
          {hash ? (
            <a target="_blank" rel="noopener noreferrer" href={scanTx(hash)}>
              {strDot(hash)}
            </a>
          ) : (
            <span title={txt}>{txt}</span>
          )}
          {hash && (
            <CopyToClipboard text={hash} onCopy={onCopy}>
              {/* <Tooltip title="Copy">
                  <CopyOutlined />
                </Tooltip> */}
              <CopyOutlined />
            </CopyToClipboard>
          )}
          {msg && <span>{msg}</span>}
        </> : replaceContent
      }
    </Tag>
  );
};

export default TransactionTag;
